import React from 'react';
import styled from 'styled-components';
import { colors, transition } from '../../../utils/styles';

import { translate } from '../../../../i18n';
import { LinkButton } from '../../commons';

const t = translate('components/products/membership/CheckList');

const { GATSBY_MANAGER_URL } = process.env;

const ChecklistTileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 15px;

  @media (min-width: 901px) {
    width: 52.32%;
    margin: 0 auto;
  }
`;

const ChecklistTile = styled.div`
  width: 96%;
  height: 66px;
  margin: 0 auto 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;

  @media (min-width: 901px) {
    width: 88%;
    margin-left: 12%;
  }
`;

const ChecklistTileImg = styled.i`
  font-size: 33px;
  color: ${ colors.mainBlue };
  padding-left: 32px;

  @media (max-width: 900px) {
    padding-left: 18px;
  }
`;

const ChecklistTileContent = styled.h3`
  font-size: 15px;
  line-height: 1.3;
  margin-left: 16px;
  margin-right: 15px;
  font-weight: normal;
`;

const TryItTodayBtn = styled.a`
  margin-top: 10px;
  width: fit-content;
  padding: 0 30px;
  height: 42px;
  border-radius: 32px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
  color: white;
  background-color: #00a7ff;
  text-align: center;
  line-height: 2.75;
  margin-left: 12%;
  margin-top: 10px;
  font-weight: 700;

  @media (max-width: 900px) {
    margin-left: 0;
    margin: 10px auto 0;
    line-height: 3.2;
    font-weight: 700;
  }

  &:hover {
    background-color: white;
    color: ${ colors.mainBlue };
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  ${ transition('all 0.3s ease') };
`;

const checkListItems = list =>
  list.map(str => (
    <ChecklistTile key={ str }>
      <ChecklistTileImg className='fas fa-check-circle' />
      <ChecklistTileContent>{ str }</ChecklistTileContent>
    </ChecklistTile>
  ));

export default ({ list, buttonText, url, source }) => (
  <ChecklistTileWrapper>
    { checkListItems(list) }
    <LinkButton
      id={ `${ source }_checklist_cta` }
      css='margin-left: auto'
      blue
      href={ url }
      text={ buttonText }
    />
  </ChecklistTileWrapper>
);



// WEBPACK FOOTER //
// ./src/components/products/membership/CheckList.js